import { Routes } from '@angular/router';
import { AppLayout } from './app/core/auth-layout/component/app.layout';


import { Notfound } from './app/pages/notfound/notfound';

import { Empty } from './app/pages/empty/empty';
import { Landing } from './app/features/landing/landing.component';
import { authGuard } from './app/core/guards/auth.guard';
import { DashboardComponent } from './app/features/dashboard/dashboard.component';
import { landingGuard } from './app/core/guards/landing.guard';

export const appRoutes: Routes = [

    // PUBLIC LANDING
    {
        path: '',
        pathMatch: 'full',
        component: Landing,
        canActivate: [landingGuard],
    },

    // PUBLIC LOGIN
    {
        path: 'login',
        loadComponent: () =>
            import('./app/features/authentication/login/login.component')
                .then(c => c.LoginComponent)
    },

    // PROTECTED APPLICATION
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard({})],

        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
            },
            {
                path: 'upload',
                loadComponent: () =>
                    import('./app/features/files/pages/upload/upload.component')
                        .then(c => c.UploadComponent),
                canActivate: [authGuard({})],
            },

            {
                path: 'seed-export',
                loadComponent: () =>
                    import('./app/features/db-seed/pages/extract/seed-export.component')
                        .then(c => c.SeedExportComponent),
                canActivate: [authGuard({})],
            },

            {
                path: 'seed-import',
                loadComponent: () =>
                    import('./app/features/db-seed/pages/import/seed-import.component')
                        .then(c => c.SeedImportComponent),
                canActivate: [authGuard({})],
            },


            {
                path: 'users',
                loadChildren: () =>
                    import('./app/features/users/users.routes')
                        .then(c => c.usersRoutes)
            },

            {
                path: 'rules',
                loadChildren: () =>
                    import('./app/features/rules/rules.routes')
                        .then(c => c.rulesRoutes)
            },

            {
                path: 'roles',
                loadChildren: () =>
                    import('./app/features/roles/roles.routes')
                        .then(c => c.rolesRoutes)
            },

            {
                path: 'access-denied',
                loadComponent: () =>
                    import('./app/pages/access/access')
                        .then(c => c.Access)
            },
        ],
    },

    {
        path: 'not-found',
        loadComponent: () =>
            import('./app/pages/notfound/notfound')
                .then(c => c.Notfound)
    },

    {
        path: 'error',
        loadComponent: () =>
            import('./app/pages/error/error')
                .then(c => c.Error)
    },

    {
        path: '**',
        redirectTo: '/not-found'
    }
];
